import angular from 'angular';

angular.module('cloudX').factory('templateInterceptorSvc', [
  'buildversion',
  function(buildVersion) {
    return {
      request: function(config) {
        if (config && config.url && config.url.indexOf('assets/templates/') >= 0) {
          config.params = { ...config.params, v: buildVersion };
        }
        return config;
      },
    };
  },
]);
